"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

function capitalize(text) {
  return text.toString().charAt(0).toUpperCase() + text.toString().slice(1);
}

var _default = capitalize;
exports["default"] = _default;